import React, { ChangeEvent, Dispatch } from "react";
import { ITaxesMenuItemState } from "../types";
import { replaceSelectedList, updateFilterState } from "../state";
import Filters, { sortFilterItems } from "../../menu/products/Filters";
import { Button, InputAdornment, TextField } from "@material-ui/core";
import Styles from "../../../scss/taxes.module.scss";
import { ReactComponent as SearchIcon } from "../../../assets/images/icon-search.svg";
import { setSearchText } from "../state/TaxesMenuItems.actions";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

interface ITaxesControls extends Partial<ITaxesMenuItemState> {
  dispatch: Dispatch<any>;
  isFilter?: boolean;
  taxName: string | null;
}

export function TaxesControls({
  dispatch,
  itemList,
  filterList,
  filterState,
  selectedList,
  searchText,
  taxName,
  isFilter = true,
}: ITaxesControls) {
  const { t } = useTranslation();
  function setFilters(_: any, filterState: Record<string, boolean>) {
    dispatch(updateFilterState(filterState));
  }
  function selectAllFilters() {
    let list = itemList;
    if (filterState && filterList && itemList) {
      list = sortFilterItems(filterList, filterState, itemList);
    }
    if (list) {
      dispatch(replaceSelectedList(list));
    }
  }
  function selectNoFilters() {
    dispatch(replaceSelectedList([]));
  }
  function onChangeSearchText(ev: ChangeEvent<HTMLInputElement>) {
    dispatch(setSearchText(ev.target.value));
  }
  return (
    <div className={Styles.MenuControls}>
      <div>
        <div>
          {isFilter && filterState && filterList && (
            <span>
              {taxName ? <span>{t("taxes.dialog.info", { taxName })}</span> : <Skeleton variant="text" />}
              <span>
                {t("taxes.dialog.applied", { count: selectedList?.length })}
              </span>
            </span>
          )}
          <div>
            <Button
              onClick={selectNoFilters}
              variant="contained"
              data-component-name="CREATE_NEW"
              disabled={selectedList?.length === 0}
              size="small"
            >
              {t("taxes.dialog.selectNone")}
            </Button>
            <Button
              onClick={selectAllFilters}
              disabled={selectedList?.length === itemList?.length}
              variant="contained"
              data-component-name="CREATE_NEW"
              size="small"
            >
              {t("taxes.dialog.selectAll")}
            </Button>
          </div>
        </div>

        <div>
          {isFilter && filterState && filterList && (
            <div>
              <TextField
                variant="outlined"
                size="small"
                value={searchText}
                onChange={onChangeSearchText}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                placeholder={t("taxes.dialog.searchText")}
              />
            </div>
          )}

          {isFilter && filterState && filterList && (
            <div>
              <Filters
                defaultFilters={filterState}
                filterkey={"subcatfilter"}
                allFilters={filterList}
                setFilterState={setFilters}
                filterTitle={t("taxes.dialog.filter")}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
